export enum PaymentTypeKeys {
  none      = 1,
  immediate = 2
}
